import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';
import {omit} from 'ramda';
import React from 'react';

const DropdownFilter = ({value, options, onFilterChange, style, ...props}) => {
  return (
    <div style={{display: 'flex', ...style}} {...omit(['filterName'], props)}>
      <Select
        value={value}
        multiple
        onChange={e => onFilterChange(e.target.value)}
        style={{width: '100%'}}
      >
        {options.map(({label}) => (
          <MenuItem key={label} value={label}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

DropdownFilter.propTypes = {
  filterName: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func,
  value: PropTypes.array.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  style: PropTypes.object,
};

export default DropdownFilter;
